import { memo } from 'react';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

interface Props {
    showDeleted: boolean;
    setShowDeleted: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeletedResultsButton = ({ setShowDeleted, showDeleted }: Props) => {
    return (
        <ToggleButtonGroup
            color="primary"
            value={showDeleted}
            exclusive
            onChange={() => setShowDeleted(!showDeleted)}
            aria-label="Deleted"
            sx={{ marginRight: '2rem' }}
        >
            <ToggleButton value={false} sx={{ paddingTop: 0.75, paddingBottom: 0.75 }}>
                Active
            </ToggleButton>
            <ToggleButton value={true} sx={{ paddingTop: 0.75, paddingBottom: 0.75 }}>
                Archived
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default memo(DeletedResultsButton);
